import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { Box, Button, Flex, VStack, Text, Image } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { CheckboxConfirm } from './checkbox-confirm'
import { cardImageMap } from '../../state/interfaces'
import { useSelector } from 'react-redux'
import { selectScenario } from '../../state'

export interface CheckboxConfirmProps {
  onChange?: (newValues: string[]) => void
  onConfirm?: (values: string[]) => void
  grandImage?: string
}

export const CheckboxesConfirm: FC<CheckboxConfirmProps> = ({ onConfirm, grandImage }) => {
  const { t } = useTranslation()

  const [selectedChoices, setSelectedChoices] = useState<string[]>([])
  const [isConfirmedPrice, setIsConfirmedPrice] = useState(false)
  const scenario = useSelector(selectScenario)
  const scenarioType = scenario?.type

  const handleCheckboxChange = (value: string, checked: boolean) => {
    if (checked) {
      setSelectedChoices((prevSelected) => [...prevSelected, value])
    } else {
      setSelectedChoices((prevSelected) => prevSelected.filter((val) => val !== value))
    }
  }
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  useEffect(() => {
    setIsConfirmedPrice(selectedChoices.includes('confirm-alert'))
  }, [selectedChoices])

  const confirmChoices = useCallback(() => {
    onConfirm && onConfirm(selectedChoices)
  }, [onConfirm, selectedChoices])

  return (
    <VStack>
      <Flex direction="column" marginY={5} maxW={{ md: 600 }}>
        <label>
          <Box border="1px solid lightgrey" borderRadius={6}>
            <Box display="flex" width="100%" paddingX={6} paddingY={2}>
              <Flex alignItems="center" minW={{ base: 120, md: 200 }}>
                <Flex border="1px solid lightgrey" alignItems="center" mt={1} minW={'18px'} zIndex={2}>
                  <CheckboxConfirm value="confirm-alert" onChange={handleCheckboxChange} />
                </Flex>
                <Text ml={4} whiteSpace="normal" cursor="pointer" fontSize={{ base: '14', md: '16' }}>
                  <strong>
                    {t('mandatory-confirmation-title')}{' '}
                    <span style={{ color: 'red', textTransform: 'uppercase' }}>*</span>
                  </strong>
                  <br />
                  {scenarioType === 'mobile-reviews' || scenarioType === 'internet-reviews'
                    ? t('mandatory-confirmation-text-no-email')
                    : t('mandatory-confirmation-text')}
                </Text>
              </Flex>
            </Box>
          </Box>
        </label>
        <label>
          <Box
            backgroundColor="#e8e8e8"
            borderRadius={6}
            mt={4}
            opacity={isConfirmedPrice ? 1 : 0.4}
            pointerEvents={isConfirmedPrice ? 'auto' : 'none'}
          >
            <Box display="flex" width="100%" paddingX={6} paddingY={2}>
              <Flex alignItems="center" minW={{ base: 120, md: 200 }}>
                <Flex border="1px solid lightgrey" alignItems="center" mt={1} minW={'18px'} zIndex={2}>
                  <CheckboxConfirm
                    value="confirm-newsletters"
                    onChange={handleCheckboxChange}
                    isDisabled={!isConfirmedPrice}
                  />
                </Flex>
                <Text ml={4} whiteSpace="normal" cursor="pointer" fontSize={{ base: '14', md: '16' }}>
                  <strong>{t('optional-confirmation-title')}</strong>
                  <br />
                  {t('optional-confirmation-text')}
                </Text>
              </Flex>
            </Box>
          </Box>
        </label>
      </Flex>
      <Button
        onClick={confirmChoices}
        disabled={!isConfirmedPrice}
        variant="solid"
        color="white"
        backgroundColor="green.600"
        fontSize="xs"
        fontWeight="bold"
        borderWidth="2px"
        borderColor="green.600"
        px={16}
        py={6}
        _focus={{
          borderColor: 'brand',
          boxShadow: '0 0 0 2px #5bce4c',
        }}
      >
        {t('common_continue')}
      </Button>
      {image && <Image src={image} alt="image" width={['60%', '45%']} />}
    </VStack>
  )
}
